export default "__VITE_ASSET__2A5YcsaM__"